export default __webpack_public_path__ + "static/media/chevron-right-blue.d2af4274.svg";